export default "assets/images/home-logo-5d875839.svg";